import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { useEffect, useState } from "react";
import { Instagram, Youtube } from "lucide-react";
import { publicApi } from "@/lib/api";

export default function Footer() {
  const { t } = useLanguage();
  const [cfg, setCfg] = useState({ email: "", whatsapp: "", instagram: "", youtube: "" });
  useEffect(() => {
    publicApi.config().then(setCfg).catch(() => {});
  }, []);

  return (
    <footer data-testid="site-footer" className="bg-obsidian text-obsidian-text mt-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="font-serif text-3xl mb-4">JK Invest Group</div>
          <p className="text-obsidian-muted text-sm max-w-md leading-relaxed">
            {t("brand.tagline")}
          </p>
        </div>

        <div>
          <div className="overline text-obsidian-muted mb-4">
            {t("nav.properties")}
          </div>
          <ul className="space-y-3 text-sm">
            <li><Link data-testid="footer-link-villas" to="/properties?type=villa" className="hover:text-obsidian-accent">Villas</Link></li>
            <li><Link data-testid="footer-link-apts" to="/properties?type=apartment" className="hover:text-obsidian-accent">Apartments</Link></li>
            <li><Link data-testid="footer-link-off" to="/off-market" className="hover:text-obsidian-accent">Off-Market</Link></li>
            <li><Link data-testid="footer-link-services" to="/services" className="hover:text-obsidian-accent">{t("nav.services")}</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline text-obsidian-muted mb-4">{t("nav.contact")}</div>
          <ul className="space-y-3 text-sm text-obsidian-text/90">
            {cfg.email && (
              <li>
                <a data-testid="footer-email" href={`mailto:${cfg.email}`} className="hover:text-obsidian-accent">
                  {cfg.email}
                </a>
              </li>
            )}
            {cfg.whatsapp && (
              <li>
                <a
                  data-testid="footer-whatsapp"
                  href={`https://wa.me/${cfg.whatsapp}?text=${encodeURIComponent(t("contact.whatsapp_prefill"))}`}
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-obsidian-accent"
                >
                  +{cfg.whatsapp}
                </a>
              </li>
            )}
            <li className="text-obsidian-muted whitespace-pre-line">{t("contact_page.office_addr")}</li>
            <li className="pt-2">
              <div className="flex items-center gap-3">
                {cfg.instagram && (
                  <a
                    data-testid="footer-instagram"
                    href={cfg.instagram}
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Instagram"
                    className="w-10 h-10 border border-obsidian-line rounded-full flex items-center justify-center hover:border-obsidian-accent hover:text-obsidian-accent transition-colors"
                  >
                    <Instagram size={16} strokeWidth={1.6} />
                  </a>
                )}
                {cfg.youtube && (
                  <a
                    data-testid="footer-youtube"
                    href={cfg.youtube}
                    target="_blank"
                    rel="noreferrer"
                    aria-label="YouTube"
                    className="w-10 h-10 border border-obsidian-line rounded-full flex items-center justify-center hover:border-obsidian-accent hover:text-obsidian-accent transition-colors"
                  >
                    <Youtube size={16} strokeWidth={1.6} />
                  </a>
                )}
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-obsidian-line">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-obsidian-muted">
          <div>© {new Date().getFullYear()} JK Invest Group. {t("footer.rights")}</div>
          <Link data-testid="footer-admin-link" to="/admin" className="hover:text-obsidian-accent">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
